module.exports = __webpack_public_path__ + "img/brandClient.589007cc.jpg";